import { genId } from "../../../utils";

const preambleBlockSchema = {
  _id: genId(),
  name: 'preambleBlockSchema',
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: { as: 'div', className: "schema volatile-block" },
      children: [
        {
          name: 'header',
          type: 'Container',
          displaySettings: { as: 'Container', className: "block-header block-header-top" },
          children: [
            {
              name: 'title',
              type: 'text',
              placeholder: 'Preamble Block name',
              displaySettings: { className: '', size: 'sm' }
            },
            {
              name: 'utilsContainer',
              type: 'Container',
              displaySettings: { as: 'div' },
              children: [
                {
                  name: 'utilsRow',
                  type: 'Container',
                  displaySettings: { as: 'Row' },
                  children: [
                    { name: 'reportBlockUtilities', type: 'reportBlockUtilities' }
                  ]

                },
              ]
            }
          ]
        },

        {
          name: 'preparedRow',
          type: 'Container',
          displaySettings: { as: 'Container', className:'block-body' },
          children: [
            {
              name: 'textblock1',
              type: 'text',
              placeholder: 'Optional: write your note here …',
              label: 'Free-form note'
            },
            {
              name: 'preambleImage',
              type: 'image',
              placeholder: 'Image',
              label: 'Image'
            },
            {
              name: 'caption',
              type: 'text',
              placeholder: 'Caption',
              label: 'Caption'
            },
            {
              name: 'textblock2',
              type: 'text',
              placeholder: 'Optional: write your note here …',
              label: 'Free-form note'
            }
          ]
        }
      ]
    }
  ]
}

export { preambleBlockSchema }